module.exports = __webpack_public_path__ + "img/banner2.bae234c.png";